"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("@material-ui/core/styles");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var typography = _ref.typography;
  return {
    first: {
      gridColumn: '1 / -1',
      marginBottom: '1rem'
    },
    listWrapper: {
      alignItems: 'flex-start'
    },
    avatarImg: {
      borderRadius: '0',
      marginTop: '.5rem',
      width: '6.25rem',
      height: '6.25rem',
      marginRight: '2rem'
    },
    content: {
      alignSelf: 'flex-start'
    },
    subtitle1: {
      fontWeight: typography.fontWeightBold,
      fontSize: '1.3rem'
    },
    subtitle2: {
      fontWeight: typography.fontWeightBold,
      fontSize: '.9rem',
      marginBottom: '.5rem'
    },
    body1: {
      fontSize: '1rem'
    }
  };
});
var _default = useStyles;
exports["default"] = _default;